<template>
  <div id="app">
    <vs-row>
      <vs-col vs-type="flex" vs-w="4" vs-sm="6" vs-xs="12">
        <vs-card style=" border-radius: 20px">
          <img src="../../../../../assets/images/ptt2.gif" />
        </vs-card>
      </vs-col>
      <vs-col vs-w="8">
        <div>
          <vs-row vs-align="flex-start" vs-justify="space-around" vs-w="13">
            <vs-col vs-type="flex" vs-justify="space-between" vs-w="19">
              <vs-card
                class="mr-3"
                style=" background: linear-gradient(45deg,#00d4ff,#005fff); border-radius: 15px; margin-left: -15px;"
              >
                <div slot="header">
                  <vs-row>
                    <vs-col>
                      <h6 align="center">
                        <vs-icon icon="person" size="small"></vs-icon> Today
                        Manpower Status
                      </h6>
                    </vs-col>
                  </vs-row>
                  <h6 class="mt-3" align="center">
                    Active Worker : <b>{{ actual }}</b>
                  </h6>
                </div>
              </vs-card>

              <vs-card
                class="mr-5"
                style=" background: linear-gradient(45deg,#ffe700,#ff8800); border-radius: 15px;"
              >
                <div slot="header">
                  <vs-row>
                    <vs-col>
                      <h6 align="center">
                        <vs-icon
                          class="mr-2"
                          icon="build"
                          size="small"
                        ></vs-icon
                        >Today Asset Status
                      </h6>
                    </vs-col>
                  </vs-row>
                  <h6 class="mt-3" align="center">
                    Active Asset {{ asset }}/{{ totalAsset }}
                  </h6>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>

          <vs-card style=" border-radius: 20px;">
            <vs-row id="center">
              <vs-list-header
                title="Total Manhour Worker"
                style="font-size: 18px;"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <vs-button
                radius
                class="mr-2"
                color="#333f50"
                type="flat"
                @click="openPopupCreateManhourGraph"
                icon="mode_edit"
                align="right"
              ></vs-button>
              <vs-button
                radius
                class="mr-2"
                color="#333f50"
                type="flat"
                @click="setManhourGraph"
                icon="build"
                align="right"
              ></vs-button>
              <vs-button
                radius
                class="mr-2"
                color="#333f50"
                type="flat"
                @click="exportXLSX"
                icon="cloud_download"
                align="right"
              ></vs-button>
              <vs-button
                radius
                class="mr-2"
                color="#333f50"
                type="flat"
                @click="exportPDF"
                icon="picture_as_pdf"
              ></vs-button>
            </vs-row>
            <div ref="pdf">
              <!-- <ManpowerChart :totalManhour="this.totalManhour" :dateManhour="this.dateManhour" style="height: 200px;" /> -->
              <BarChart style="height: 200px;" />
              <!-- <BarChart
                :totalManhour="this.totalManhour"
                :dateManhour="this.dateManhour"
                style="height: 200px;"
              /> -->
            </div>
          </vs-card>
        </div>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="6">
        <vs-card style="  border-radius: 15px;  padding-left: 5">
          <vs-table :data="dataTpr" max-items="4" pagination>
            <template slot="header">
              <vs-list-header
                title="Worker Tags"
                style="font-size: 18px;"
                color="dark"
              ></vs-list-header>
            </template>
            <template slot="thead">
              <vs-th sortKey="name">
                Name <vs-icon icon="swap_vert" size="small"></vs-icon>
              </vs-th>
              <vs-th>
                Mac Address
              </vs-th>
              <vs-th>
                Distance Form Gateway
              </vs-th>
              <vs-th>
                rssi (2Bm)
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  <vs-button
                    id="noWrap"
                    @click="viewSensor(tr)"
                    icon="signal_cellular_alt"
                    type="flat"
                    >{{ data[indextr].name }}</vs-button
                  >
                </vs-td>

                <vs-td :data="data[indextr].mac">
                  {{ data[indextr].mac }}
                </vs-td>
                <vs-td :data="data[indextr].dis">
                  {{ data[indextr].dis }}
                </vs-td>

                <vs-td :data="data[indextr].rssi">
                  {{ data[indextr].rssi }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </vs-col>
      <vs-col vs-w="6">
        <vs-card style="  border-radius: 15px;  padding-left: 5">
          <vs-table :data="assetfound" max-items="4" pagination>
            <template slot="header">
              <vs-list-header
                title="Asset Tags"
                style="font-size: 18px;"
                color="dark"
              ></vs-list-header>
            </template>
            <template slot="thead">
              <vs-th sortKey="name">
                Name <vs-icon icon="swap_vert" size="small"></vs-icon>
              </vs-th>
              <vs-th>
                Mac Address
              </vs-th>
              <vs-th>
                Distance Form Gateway
              </vs-th>
              <vs-th>
                rssi(2Bm)
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  <vs-button
                    id="noWrap"
                    @click="viewSensor(tr)"
                    icon="signal_cellular_alt"
                    type="flat"
                    >{{ data[indextr].name }}</vs-button
                  >
                </vs-td>

                <vs-td :data="data[indextr].mac">
                  {{ data[indextr].mac }}
                </vs-td>
                <vs-td :data="data[indextr].dis">
                  {{ data[indextr].dis }}
                </vs-td>

                <vs-td :data="data[indextr].rssi">
                  {{ data[indextr].rssi }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>
      </vs-col>
    </vs-row>
    <b-modal
      size="lg"
      ref="my-modal-createManhour"
      hide-footer
      title="Create Manhour"
    >
      <vs-row>
        <vs-col type="flex" vs-justify="center" vs-w="12">
          <label for="example-input">Target</label>
          <b-input
            v-model.number="targetValue"
            class="inputx"
            placeholder="target"
            style="border-radius: 15px;"
          />
          <label for="example-input" class="mt-2">Choose a date</label>
          <datetime
            v-model="targetDatevalue"
            type="datetime"
            input-class="form-control"
            placeholder="YYYY/MM/DD H:i:s"
          ></datetime>
          <vs-alert :active.sync="alertDate" closable close-icon="close" color="danger">
            Date is required
          </vs-alert>
        </vs-col>
      </vs-row>
      <vs-row class="mt-3">
        <vs-col
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          class="text-right"
        >
          <vs-button
            @click="SaveCreateManhourGraph"
            color="primary"
            type="filled"
            class="mr-2"
            >Save</vs-button
          >
          <vs-button
            @click="ClosePopupCreateManhourGraph"
            color="grey"
            type="filled"
            >Cancel</vs-button
          >
        </vs-col>
      </vs-row>
    </b-modal>
    <b-modal
      size="lg"
      ref="my-modal-setManhour"
      hide-footer
      title="Set Manhour"
    >
      <vs-table :data="dataMergeManHour">
        <template slot="thead">
          <vs-th>
            Date Toltal Manhour
          </vs-th>
          <vs-th>
            Toltal Manhour
          </vs-th>
          <vs-th>
            Date Target Manhour
          </vs-th>
          <vs-th>
            Target Manhour
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.indoorTagManHour.date">
              {{ tr.indoorTagManHour.date }}
            </vs-td>
            <vs-td :data="tr.indoorTagManHour.manhour">
              {{ tr.indoorTagManHour.manhour }}
            </vs-td>
            <vs-td :data="tr.indoorManHour.date">
              {{ tr.indoorManHour.date }}
            </vs-td>
            <vs-td :data="tr.indoorManHour.target">
              <vs-input
                v-model="tr.indoorManHour.target"
                class="inputx"
                placeholder="target"
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-row class="mt-3">
        <vs-col
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          class="text-right"
        >
          <vs-button
            @click="SaveSetManhourGraph"
            color="primary"
            type="filled"
            class="mr-2"
            >Save</vs-button
          >
          <vs-button
            @click="ClosePopupSetManhourGraph"
            color="grey"
            type="filled"
            >Cancel</vs-button
          >
        </vs-col>
      </vs-row>
    </b-modal>
  </div>
</template>

<script>
import { Draggable } from "draggable-vue-directive";
// import ManpowerChart from "./components/ManpowerChart.vue";
 import BarChart from "./BarChart.vue";
// import BarChart from "../../../Page/IndoorTracking/components/BarChart.vue";
import moment from "moment";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
export default {
  components: {
    // ManpowerChart,
    BarChart,
  },
  directives: {
    Draggable,
  },

  data: () => ({
    gateway: [],
    tagfound: [],
    dataTpr: [],
    realData: [],
    actual: 0,
    today: 0,
    total: 0,
    asset: 0,
    totalAsset: 0,
    tpr: 0,
    totalManhour: [],
    dateManhour: [],
    totalManhorExport: [],
    assetfound: [],
    tprAsset: [],
    resultIndoorManHour: [],
    resultIndoorTagManHour: [],
    dataMergeManHour: [],
    show: true,
    alertDate: false,
    targetDatevalue: "",
    targetValue: 0,
    activeLoading:false,
    interval:null,
  }),
  created() {
    // console.log('Hi from PTT Dashboard')
    this.$API.get("indoormanhour").then((result) => {
      result.data.result.forEach((element) => {
        let subDate = element.date.substring(0, 10);
        this.resultIndoorManHour.push({
          date: subDate,
          id: element.id,
          target: element.target,
          username: element.username,
        });
      });
      this.resultIndoorManHour.sort(function(a, b) {
        a = a.date.split("-");
        b = b.date.split("-");
        return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
      });
      // console.log("this.resultIndoorManHour", this.resultIndoorManHour);
    });
    this.$API.get("indoortag/manhour").then((result) => {
      this.resultIndoorTagManHour = result.data;
      this.resultIndoorTagManHour.sort(function(a, b) {
        a = a.date.split("-");
        b = b.date.split("-");
        return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
      });
      // console.log("this.resultIndoorTagManHour", this.resultIndoorTagManHour);
    });
    //  this.showGateway();
    this.getTotalManhour();
    this.getTotalAsset();
    this.getTodaytag();
    this.getTagRealtime();
    this.getAssetRealtime();
    this.getGateway();

    this.callData()
    // setInterval(() => {
    //   this.getTotalAsset();
    //   this.getTodaytag();
    //   this.getTagRealtime();
    //   this.getAssetRealtime();
    // }, 5000);
  },
  beforeDestroy(){
    clearTimeout(this.interval)
  },
  methods: {
    async callData(){
      this.interval = setTimeout(async() => {
     await  this.getTotalAsset();
     await  this.getTodaytag();
     await  this.getTagRealtime();
     await  this.getAssetRealtime();
     this.callData()
    }, 5000);
    },
      openLoading(){
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      setTimeout( ()=> {
        this.activeLoading = false
        this.$vs.loading.close()
      }, 3000);
    },
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD;
    },
    openPopupCreateManhourGraph() {
      this.targetValue = 0;
      this.targetDatevalue = "";
      this.$refs["my-modal-createManhour"].show();
    },
    setManhourGraph() {
      this.$refs["my-modal-setManhour"].show();
      this.dataMergeManHour = [];
      this.resultIndoorManHour.forEach((element) => {
        this.resultIndoorTagManHour.forEach((element2) => {
          if (element.date === element2.date) {
            if(element2.manhour){
              this.dataMergeManHour.push({
              indoorManHour: {
                date: element.date,
                id: element.id,
                target: element.target,
                username: element.username,
              },
              indoorTagManHour: {
                date: element2.date,
                manhour: element2.manhour,
              },
            });
            } else {
               this.dataMergeManHour.push({
              indoorManHour: {
                date: element.date,
                id: element.id,
                target: element.target,
                username: element.username,
              },
              indoorTagManHour: {
                date: element2.date,
                manhour: 0,
              },
            });
            }
            
          }
        });
      });
    },
    ClosePopupCreateManhourGraph() {
      this.$refs["my-modal-createManhour"].hide();
    },
    ClosePopupSetManhourGraph() {
      this.$refs["my-modal-setManhour"].hide();
    },
    SaveCreateManhourGraph() {
      if (this.targetDatevalue) {
        this.openLoading()
        this.alertDate = false;
        const data = {
          target: this.targetValue,
          date: this.targetDatevalue,
        };
        this.$API
          .post("indoormanhour/create", data)
          .then((res) => {
            if (res.status === 400) {
              alert("SAVE ERROR");
            } else {
              location.reload();
              this.$refs["my-modal-createManhour"].hide();
            }
          })
          .catch((err) => {
            return err.response;
          });
      } else {
        this.alertDate = true;
      }
    },
    SaveSetManhourGraph() {
      // console.log(this.dataMergeManHour);
      this.openLoading()
      let count = 0;
      const length = this.dataMergeManHour.length;
      this.dataMergeManHour.forEach((element) => {
        count += 1;
        const data = {
          id: element.indoorManHour.id,
          target: element.indoorManHour.target,
        };
        this.$API
          .put("indoormanhour/update", data)
          .then((res) => {
            if (length === count) {
              this.$refs["my-modal-setManhour"].hide();
              location.reload();
              return res;
            }
          })
          .catch((err) => {
            return err.response;
          });
      });
    },
    // onFileChange(e) {
    //   const file = e.target.files[0];
    //   this.url = URL.createObjectURL(file);
    // },
    viewSensor(item) {
      // console.log(item.mac);
      this.$session.set("sensorname", item.name);
      this.$session.set("macname", item.mac);
      this.$session.set("type", item.type);

      // console.log(this.network,item)
      this.$router.push({
        name: "SensorDashboardIndoor",
        params: {
          sensorname: this.name,
          macname: this.mac,
        },
      });
    },

    getTagRealtime() {
      this.tagfound = [];
      this.$API.get("indoorgateway/AC233FC0649B").then((result1) => {
        // console.log(result1.data[0].assetfound);
        this.actual = result1.data[0].tagfound.length;
        //console.log(this.actual);
        for (var i = 0; i <= result1.data[0].tagfound.length; i++) {
          let obj = result1.data[0].tagfound[i];
          if (obj !== undefined) {
            // console.log('getTagRealtime', obj);
            this.$API.get("indoortag/" + obj.mac).then((result2) => {
              //console.log(result2.data);
              if (obj.mac == result2.data[0].mac) {
                //console.log(result2.data[0].name);

                let payload = {
                  mac: obj.mac,
                  name: result2.data[0].name,
                  dis: Math.pow(10, (-52 - obj.rssi) / (10 * 4)).toFixed(2),
                  rssi: obj.rssi,
                };
                this.tagfound.push(payload);
                payload = {};
                //console.log(this.found);
                // this.realData=this.dataTpr;
                // // this.found.push(this.dataTpr);
              }
            });
          }
        }
      });
      setTimeout(() => {
        this.dataTpr = this.tagfound;
      }, 300);
    },
    getAssetRealtime() {
      this.tprAsset = [];
      this.$API.get("indoorgateway/AC233FC0649B").then((result1) => {
        // console.log("result1", result1);
        this.asset = result1.data[0].assetfound.length;
        //console.log(this.actual);
        for (var i = 0; i <= result1.data[0].assetfound.length; i++) {
          let obj = result1.data[0].assetfound[i];
          if (obj !== undefined) {
            // console.log("getAssetRealtime", obj);
            this.$API.get("indoorasset/" + obj.mac).then((result2) => {
              //console.log(result2.data);
              if (obj.mac == result2.data[0].mac) {
                //console.log(result2.data[0].name);

                let payload = {
                  mac: obj.mac,
                  name: result2.data[0].name,
                  dis: Math.pow(10, (-52 - obj.rssi) / (10 * 4)).toFixed(2),
                  rssi: obj.rssi,
                };
                this.tprAsset.push(payload);
                payload = {};
                //console.log(this.found);
                // this.realData=this.dataTpr;
                // // this.found.push(this.dataTpr);
              }
            });
          }
        }
      });
      setTimeout(() => {
        this.assetfound = this.tprAsset;
      }, 300);
    },
    getGateway() {
      this.$API.get("indoorgateway/AC233FC0649B").then((result) => {
        // console.log(result.data);
        this.gateway = result.data;
      });
    },
    getTodaytag() {
      this.tpr = 0;
      this.$API.get("indoortag").then((result) => {
        // console.log(result.data);
        this.total = result.data.length;
        for (var i = 0; i < result.data.length; i++) {
          //console.log(result.data[0].firstdate);
          // console.log(moment(result.data[0].firstdate).format('l'));
          if (
            moment(result.data[i].firstdate).format("l") == moment().format("l")
          ) {
            this.tpr++;
            // console.log(this.today);
          }
        }
      });
      setTimeout(() => {
        this.today = this.tpr;
      }, 300);
    },
    getTotalAsset() {
      this.$API.get("indoorasset").then((result) => {
        // console.log(result.data.length);
        this.totalAsset = result.data.length;
      });
    },
    getTotalManhour() {
      // this.$API.get("indoortag/manhour").then((result) => {
      //   console.log(result.data);
      //   for (var i = 0; i <= result.data.length; i++) {
      //     let obj = result.data[i];
      //     //  console.log(obj.manhour);
      //     if (obj.manhour != null) {
      //       let payload = { date: obj.date, manhour: obj.manhour };
      //       this.totalManhorExport.push(payload);
      //       this.totalManhour.push(obj.manhour);
      //       this.dateManhour.push(obj.date);
      //       payload = {};
      //       // console.log(this.totalManhorExport);
      //     }
      //   }
      // });
      // localStorage.setItem("totalManhour", this.totalManhour);
      // localStorage.setItem("dateManhour", this.dateManhour);
    },
    exportXLSX() {
      const dataWS = XLSX.utils.json_to_sheet(this.totalManhorExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "Total_Manhour_Export.xlsx");
    },
    exportPDF() {
      let pdfRef = this.$refs.pdf;
      html2canvas(pdfRef).then((canvas) => {
        let pdfImage = canvas.toDataURL();
        let pdf = new jsPDF();
        pdf.addImage(pdfImage, "PNG", 0, 20, 200, 50);
        pdf.save("Total_Manhour_Export.pdf");
      });
    },
  },
};
</script>
<style scoped>
#app {
  padding: 20px;
}

#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}
img {
  max-width: 100%;
  max-height: 100%;
}
.vdatetime.input >>> .form-control {
    display: block;
    width: 100%;
    height: calc(1.45em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.45;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 15px;
}
</style>
